import { render, staticRenderFns } from "./RankingButton.vue?vue&type=template&id=448427f6&scoped=true"
import script from "./RankingButton.vue?vue&type=script&lang=js"
export * from "./RankingButton.vue?vue&type=script&lang=js"
import style0 from "./RankingButton.vue?vue&type=style&index=0&id=448427f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448427f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
